import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRule, styleRuleInherit} from "../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {WalletCard, WalletCardStyle} from "../../ui/WalletCard";
import {PaymentMethodStore} from "../../../State";
import {Messages} from "../../../Messages";
import {BlinkButton} from "../../../ui/Button.jsx";
import {WalletPopup} from "../../ui/WalletPopup";
import {WidgetRoutes} from "../../WidgetRoutes";
import {WALLET_CARD_CONTENT_HEIGHT} from "../../WidgetConstants";
import {PaymentMethodSelectInput} from "../../../panel/pages/panels/payment-method/components/PaymentMethodSelectInput.jsx";
import {Router} from "../../../../stem-core/src/ui/Router";
import {apiSetPrimaryPaymentMethod} from "../../../../client/state/PaymentMethodStore";
import {LoadingSpinner} from "../../../../core/ui/LoadingSpinner.jsx";


class ElementStyle extends WalletCardStyle {
    @styleRuleInherit
    container = {
        padding: "24px 0",
        minHeight: 0,
    };

    @styleRuleInherit
    content = {
        display: "flex",
        flexDirection: "column",
        height: WALLET_CARD_CONTENT_HEIGHT,
        padding: "0 24px",
    };

    @styleRule
    chooseCardContainer = {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    };
}

@registerStyle(ElementStyle)
export class WidgetChooseCardClass extends WalletCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.choosePaymentMethod,
        };
    }

    render() {
        const {styleSheet} = this;

        return <PaymentMethodSelectInput
            ref="chooseCard"
            className={styleSheet.chooseCardContainer}
            onAddCard={() => this.onAddCardClick()}
            onChange={() => this.redraw()}
        />;
    }

    onAddCardClick() {
        Router.changeURL(WidgetRoutes.ADD_CARD)
    }

    renderPrimaryButton() {
        return <BlinkButton
            testId="chooseCardButton"
            disabled={this.chooseCard?.getValue() === PaymentMethodStore.getPrimary()}
            onClick={() => this.onPrimaryButtonClick()}
            label={Messages.continue}
        />;
    }

    onPrimaryButtonClick() {
        LoadingSpinner.wrap(async () => apiSetPrimaryPaymentMethod(this.chooseCard.getValue()?.id));
        Router.back();
    }
}

export const WidgetChooseCard = WalletPopup(WidgetChooseCardClass);
